import { Button, Input, Modal, Select, Space } from "antd";
import { PlusOutlined, SettingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import textToFile2 from "controllers/textToFile2";
import s3Controller2 from "controllers/s3Controller2";
import axios from "axios";
import openAiChatCompletion from "controllers/openAiChatCompletion";

const backend = process.env.REACT_APP_BACKEND;

function ControlBox ({
  baseParams, 
  baseParamsHandler, 
  pos, 
  languageGroup, 
  stateHandler,
  selectedRows,
  stopRef,
  stopRefHandler,
  curLanguage,
  dataChangeHandler,
  gptModel,
  tableParams,
  paginationHandler
}) {

  const onSearch = (value) => {
    console.log(baseParams)
    baseParamsHandler({
      ...baseParams,
      search: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }

  const posFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      pos: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }

  const cefrOption = [
    {value: "A0", label: "A0"},
    {value: "A1", label: "A1"},
    {value: "A2", label: "A2"},
    {value: "B1", label: "B1"},
    {value: "B2", label: "B2"},
    {value: "C1", label: "C1"},
    {value: "C2", label: "C2"},
  ]
  const cefrLevelEvpFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      cefrLevelByEVP: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }
  const cefrLevelGptFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      cefrLevelByGPT: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }
  const languageFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      language: value
    })
  }

  const settingModalHandler = () => {
    stateHandler("settingModal", true)
  }

  //선택된 단어들의 오답을 만들어내는 기능
  const createWrongWord = async () => {
    stateHandler("loading", true)
    stateHandler("progress",[0,selectedRows.length])

    //에러가 났을 경우 계속 진행할지를 묻는 함수
    const modalF = (instance) => {
      return new Promise((resolve)=> {
        Modal.confirm({
          title: "서버에러",
          onCancel: () => {
            resolve(false)
          },
          onOk: () => {
            resolve(true)
          },
          okText: "계속",
          cancelText: "중지",
          content:
          instance.id +
          "번 단어에서 에러가 발생하였습니다. 나머지 단어를 계속 하시겠습니까? 아니면 중지하시겠습니까?",
        });
      })
    };
    
    // 오답을 생성하는 기능
    const createByGpt = async (record) => {
      const { word, pos_name, cefr_evp, translate_text} = record
      const prompt = `Provide one English word opposite or irrelevant to '${word}' that is a(n) ${pos_name} at the ${cefr_evp} CEFR level meaning ${translate_text}. Make sure to select the word whose part of the speech and CEFR level is the same. Provide only the English word without any explanation or other cues.`
      const wrongWordByGpt = await openAiChatCompletion(prompt, gptModel)

      return wrongWordByGpt.toLowerCase()
    }

    for(let i=0; i<selectedRows.length; i++) {
      if(stopRef.current) break
      if(!selectedRows[i].translate_text) {
        const modalF = (instance) => {
          return new Promise((resolve)=> {
            Modal.confirm({
              title: "서버에러",
              onCancel: () => {
                resolve(false)
              },
              onOk: () => {
                resolve(true)
              },
              okText: "계속",
              cancelText: "중지",
              content:
              instance.id +
              "번 단어에서 에러가 발생하였습니다. 나머지 단어를 계속 하시겠습니까? 아니면 중지하시겠습니까?",
            });
          })
        };
        const isContinue =await modalF(selectedRows[i])
        if(isContinue) {
          continue
        } else {
          break
        }
      }

      stateHandler("progress",[i+1,selectedRows.length])
      const instance = {...selectedRows[i]};

      const wrongWordByGpt = await createByGpt(instance)

      // 에러가 났을 경우 계속 여부를 묻는다.
      if(!wrongWordByGpt) {
        const isContinue = await modalF(instance)
        if(isContinue) {
          continue
        } else {
          break
        }
      }

      instance.wrong_word = wrongWordByGpt
      const values = {
        id: instance.id,
        word: instance.word,
        ContentSettingPartsOfSpeechMaster_code: instance.ContentSettingPartsOfSpeechMaster_code,
        wrong_word: wrongWordByGpt
      }
      
      try {
        const axiosResult = await axios.patch(`${backend}/contents/new_word/constituent_false/master`,{values})
        dataChangeHandler(instance, "wrong_word")
      } catch (err) {
        console.log(err)
        console.log("오답생성 답변 :",wrongWordByGpt)
        const isContinue = await modalF(instance)
        if(isContinue) {
          continue
        } else {
          break
        }
      }
    }

    stateHandler("loading", false)
    stateHandler("progress",[0,0])
    stopRefHandler()
  }


  //선택된 단어들의 cefr레벨을 생성하는 기능
  const createCefrAll = async () => {
    stateHandler("loading", true)
    stateHandler("progress",[0,selectedRows.length])

    //에러가 났을 경우 계속 진행할지를 묻는 함수
    const modalF = async (instance) => {
      return new Promise((resolve)=> {
        Modal.confirm({
          title: "서버에러",
          onCancel: () => {
            resolve(false)
          },
          onOk: () => {
            resolve(true)
          },
          okText: "계속",
          cancelText: "중지",
          content:
          instance.id +
          "번 단어에서 에러가 발생하였습니다. 나머지 단어를 계속 하시겠습니까? 아니면 중지하시겠습니까?",
        });
      })
    };
    
    // gpt요청을 보내는 기능
    const createByGpt = async (record) => {
      const { word, translate_text} = record
      const prompt = `Provide the estimated CEFR level of the word '${word}' with its Korean meaning '${translate_text}'. Provide only the CERF level without any explanation or other cues.`
      const cefrByGpt = await openAiChatCompletion(prompt, gptModel)
  
      return cefrByGpt
    }

    for(let i=0; i<selectedRows.length; i++) {
      if(stopRef.current) break
      if(!selectedRows[i].translate_text) {
        const modalF = (instance) => {
          return new Promise((resolve)=> {
            Modal.confirm({
              title: "서버에러",
              onCancel: () => {
                resolve(false)
              },
              onOk: () => {
                resolve(true)
              },
              okText: "계속",
              cancelText: "중지",
              content:
              instance.id +
              "번 단어에서 에러가 발생하였습니다. 나머지 단어를 계속 하시겠습니까? 아니면 중지하시겠습니까?",
            });
          })
        };
        const isContinue = await modalF(selectedRows[i])
        if(isContinue) {
          continue
        } else {
          break
        }
      }

      stateHandler("progress",[i+1,selectedRows.length])
      const instance = {...selectedRows[i]};

      const cefrResult = await createByGpt(instance)

      // 에러가 났을 경우 계속 여부를 묻는다.
      if(!cefrResult) {
        const isContinue = await modalF(instance)
        if(isContinue) {
          continue
        } else {
          break
        }
      }

      instance.cefr_gpt = cefrResult
      const values = {
        id: instance.id,
        word: instance.word,
        ContentSettingPartsOfSpeechMaster_code: instance.ContentSettingPartsOfSpeechMaster_code,
        cefr_gpt: cefrResult === "N/A" ? null : cefrResult
      }
      
      try {
        const axiosResult = await axios.patch(`${backend}/contents/new_word/constituent_false/master`,{values})
        dataChangeHandler(instance, "cefr_gpt")
      } catch (err) {
        console.log(err)
        console.log("cefr레벨 답변 :",cefrResult)
        const isContinue = await modalF(instance)
        if(isContinue) {
          continue
        } else {
          break
        }
      }
    }

    stateHandler("loading", false)
    stateHandler("progress",[0,0])
    stopRefHandler()
  }


  //선택된 단어들을 일괄적으로 해석하는 기능
  const translteAll = async () => {
    stateHandler("loading", true)
    stateHandler("progress",[0,selectedRows.length])

    //에러가 났을 경우 계속 진행할지를 묻는 함수
    const modalF = async (instance) => {
      return new Promise((resolve)=> {
        Modal.confirm({
          title: "서버에러",
          onCancel: () => {
            resolve(false)
          },
          onOk: () => {
            resolve(true)
          },
          okText: "계속",
          cancelText: "중지",
          content:
          instance.id +
          "번 단어에서 에러가 발생하였습니다. 나머지 단어를 계속 하시겠습니까? 아니면 중지하시겠습니까?",
        });
      })
    };
    
    // 해석파일을 생성하는 함수
    const createByGpt = async (record) => {
      const { word, pos_name, cefr_evp} = record
      const prompt = `Translate '${word}' into Korean when used as a(n) ${pos_name} at the ${cefr_evp} CEFR level. Make sure to provide ONLY ONE most used translation.`
      const translateTextByGpt = await openAiChatCompletion(prompt, gptModel)
  
      return translateTextByGpt
    }

    for(let i=0; i<selectedRows.length; i++) {
      if(stopRef.current) break
      stateHandler("progress",[i+1,selectedRows.length])
      const originRecord = JSON.parse(JSON.stringify(selectedRows[i]));
      const instance = {...selectedRows[i]};

      const translateResult = await createByGpt(instance)

      // 에러가 났을 경우 계속 여부를 묻는다.
      if(!translateResult) {
        const isContinue = await modalF(instance)
        if(isContinue) {
          continue
        } else {
          break
        }
      }

      instance.translate_text = translateResult
      const values = {
        id: instance.detail_id, 
        WordExMaster_id: instance.id,
        SystemSettingLanguage_code: instance.SystemSettingLanguage_code || curLanguage.value,
        translate_text: translateResult
      }

      try {
        const axiosResult = await axios.patch(`${backend}/contents/new_word/constituent_false/detail`, {values})
        instance.detail_id = axiosResult.data.data
        dataChangeHandler(instance, "translate_text")
      } catch (err) {
        console.log(err)
        console.log("해석: ",translateResult)
        const isContinue = await modalF(instance)
        if(isContinue) {
          continue
        } else {
          break
        }
      }
    }

    stateHandler("loading", false)
    stateHandler("progress",[0,0])
    stopRefHandler()
  }


  // 선택된 단어들의 해석 음성파일을 일괄생성하는 기능
  const createFile = async () => {
    stateHandler("loading", true)
    stateHandler("progress",[0,selectedRows.length])
    
    for(let i=0; i<selectedRows.length; i++) {
      if(stopRef.current) break
      if(!selectedRows[i].translate_text) {
        const isContinue = () => {
          return new Promise((resolve)=> {
            Modal.confirm({
              title: "빈문장 에러",
              onCancel: () => {
                resolve(false)
              },
              onOk: () => {
                resolve(true)
              },
              okText: "계속",
              cancelText: "중지",
              content:
                selectedRows[i].id +
                "번 단어의 해석이 없어 파일을 생성할 수 없습니다. 나머지 단어를 계속 하시겠습니까? 아니면 중지하시겠습니까?",
            });
          })
        }
        if(await isContinue()) {
          continue
        } else {
          break
        }
      }

      stateHandler("progress",[i+1,selectedRows.length])
      const originRecord = JSON.parse(JSON.stringify(selectedRows[i]));
      const instance = {...selectedRows[i]};

      const speedNum = 1.0;
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");

      const fileName = `word_translate_${instance.id}_${curLanguage.locale}_${currentVer}.mp3`;
      const text = instance.translate_text;
      const name = `<voice name="${curLanguage.voice_file_speaker}">`;
      const speed = `<prosody rate="${speedNum}">`;
      
      const data = await textToFile2(
        text,
        name,
        speed,
        fileName,
        `word_translate`
      );

      // 파일생성에 에러가 발생했을 경우 모달로 계속 여부를 묻는다.
      if (!data.Key) {
        const modalF = () => {
          return new Promise ((resolve) => {
            Modal.confirm({
              title: "서버에러",
              onCancel: () => {
                resolve(false)
              },
              onOk: () => {
                resolve(true)
              },
              okText: "계속",
              cancelText: "중지",
              content:
                instance.id +
                "번 단어에서 에러가 발생하였습니다. 나머지 파일을 계속 하시겠습니까? 아니면 중지하시겠습니까?",
            });
          })
        }
        
        const modalResult = await modalF();

        if (modalResult) {
          continue;
        } else {
          break;
        }
      }

      const newKey = data.Key;
      // 버전을 기록하는 뒷부분을 제외하고 prefix를 만든다. 생성 후 과거데이터를 지우기 위해서.
      const prefix = newKey.split("_").slice(0, -1).join("_");
      // 앞부분의 folder명을 제외한 순수한 파일명을 만든다. instance에 기록하기 위해서.
      const newFileName = newKey.split("/")[newKey.split("/").length - 1];
  
      instance.translate_voice_filename = newFileName;

      const values = {
        id: instance.detail_id, 
        WordExMaster_id: instance.id,
        SystemSettingLanguage_code: instance.SystemSettingLanguage_code || curLanguage.value,
        translate_voice_filename: newFileName
      }

      dataChangeHandler(instance, "translate_voice_filename")

      try{
        const axiosResult = await axios.patch(`${backend}/contents/new_word/constituent_false/detail`, {values})
        //서버에서 파일명 기록이 정상적으로 이루어졌을 경우
        if(axiosResult.status === 200) {
          // 버전을 제외한 동일한 아이디의 파일들 리스트를 받아온다.
          const result = await s3Controller2.s3List(prefix);
          // 받아온 리스트 중 새롭게 생성된 파일만 제외하고 리스트를 재작성
          const files = result.Contents.reduce((acc, cur) => {
            if (cur.Key === newKey) {
              return acc;
            } else {
              acc.push({ Key: cur.Key });
              return acc;
            }
          }, []);
          if (files.length !== 0) {
            //지워줄 파일이 있을 경우 지워준다.
            s3Controller2.s3DeleteFiles(files);
          }
        }
      } catch (err) {
        // 서버에서 에러가 발생해서 새로운 파일이름을 기록하지 못했다면 새로 생성된 파일을 지워준다.
        s3Controller2.s3DeleteFile(newKey);

        const modalF = () => {
          return new Promise((resolve)=>{
            Modal.confirm({
              title: "서버에러",
              onCancel: () => {
                resolve(false)
              },
              onOk: () => {
                resolve(true)
              },
              okText: "계속",
              cancelText: "중지",
              content:
              instance.id +
              "번 단어에서 에러가 발생하였습니다. 나머지 파일을 계속 하시겠습니까? 아니면 중지하시겠습니까",
            });
          })
        };

        const errorResult = await modalF()

        dataChangeHandler(originRecord, "word_voice_filename")
        if(errorResult) {
          continue
        } else {
          break
        }
      }   
    }
    stateHandler("loading", false)
    stateHandler("progress",[0,0])
    stopRefHandler()
  }

  return (
    <Space wrap style={{justifyContent: "end"}}>
      <Input.Search
        placeholder="영어 문장을 입력하세요."
        onSearch={onSearch}
        allowClear={true}
        style={{
          width: 250,
          marginLeft: "5px",
        }}
      />
      <Select
        options={[{ value: "all", label: "품사: 전체" }, ...pos]}
        style={{ width: 150, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.pos}
        onChange={posFilter}
      ></Select>
      <Select
        options={[{ value: "all", label: "CEFR 레벨(EVP): 전체" }, ...cefrOption]}
        style={{ width: 200, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.cefrLevelByEVP}
        onChange={cefrLevelEvpFilter}
      ></Select>
      <Select
        options={[{ value: "all", label: "CEFR 레벨(GPT): 전체" }, ...cefrOption]}
        style={{ width: 200, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.cefrLevelByGPT}
        onChange={cefrLevelGptFilter}
      ></Select>
      <Select
        options={languageGroup}
        style={{ width: 200, textAlign: "left" }}
        value={baseParams.language}
        onChange={languageFilter}
      ></Select>
      <Button onClick={settingModalHandler}>
        <SettingOutlined />설정
      </Button>
      <Button onClick={translteAll} disabled={!selectedRows.length}>
        <PlusOutlined />해석 생성
      </Button>
      <Button onClick={createCefrAll} disabled={!selectedRows.length}>
        <PlusOutlined />CEFR 레벨 생성
      </Button>
      <Button onClick={createWrongWord} disabled={!selectedRows.length}>
        <PlusOutlined />영어단어 오답 생성
      </Button>
      <Button onClick={createFile} disabled={!selectedRows.length}>
        <PlusOutlined />음성파일 생성(1.0)
      </Button>
    </Space>
  )
}

export default ControlBox